import dayjs from 'dayjs';
import {
  COMMON_MESSAGE,
  CONTRACTS_DATA,
  DISPLAY_DATE_FORMAT,
  ENTITLEMENT_DATA,
} from '../constants';

export const scrollLeft = (id) => {
  if (document.getElementById(id).scrollLeft > 0) {
    document.getElementById(id).scrollLeft -= 180;
  }
};

export const scrollRight = (id) => {
  if (document.getElementById(id).scrollLeft < 2500) {
    document.getElementById(id).scrollLeft += 180;
  }
};

export const isValidUrl = (url) => {
  try {
    return Boolean(new URL(url));
  } catch (e) {
    return false;
  }
};

// This function is used to replace elements in arr1 with elements in arr2
// arr1: array of objects
// arr2: array of objects
// key: key of the object to be compared
export const replaceElements = (arr1, arr2, key, doNotReplace = null) => {
  const idToElementMap = new Map();

  // Build a map of IDs to elements from arr2
  for (const elem of arr2) {
    idToElementMap.set(elem[key], elem);
  }

  // Iterate through arr1 and replace elements if IDs match
  for (let i = 0; i < arr1.length; i++) {
    const currElement = arr1[i];
    const correspondingElement = idToElementMap.get(currElement[key]);

    if (correspondingElement) {
      arr1[i] = correspondingElement;
    }
    // If doNotReplace is specified, then replace all keys except doNotReplace. It will keep OLD Values.
    if (doNotReplace) {
      arr1[i][doNotReplace] = currElement[doNotReplace];
    }
  }
  return arr1;
};

// parseJwt function is used to decode the token
export const parseJwt = (token) => {
  let base64Url = token.split('.')[1];
  let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  let jsonPayload = decodeURIComponent(
    window
      ?.atob(base64)
      ?.split('')
      ?.map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('')
  );

  return jsonPayload;
};

// This function is used to capitalize the first letter of the string
export const capitalizeFirstLetter = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

// This function is used to update any key in object in array of objects
// keyToMatch - The dynamic key to match
// keyValue - The value to match
// keyToUpdate - The key to update
// newValue - The new value
export const updateObjectInArray = (
  arr,
  keyToMatch,
  keyValue,
  keyToUpdate,
  newValue
) => {
  const indexToUpdate = arr.findIndex((obj) => obj[keyToMatch] === keyValue);
  if (indexToUpdate !== -1) {
    const updatedObj = { ...arr[indexToUpdate], [keyToUpdate]: newValue };
    return [
      ...arr.slice(0, indexToUpdate),
      updatedObj,
      ...arr.slice(indexToUpdate + 1),
    ];
  }
  return arr;
};

// Set Selected time on DateTimePicker to Set UTC time. It was getting change as per local time.
export const convertDateUTC = (localTime) => {
  let hours = new Date(localTime).getHours();
  let minuts = new Date(localTime).getMinutes();
  let seconds = new Date(localTime).getSeconds();
  let day = new Date(localTime).getDate();
  let month = new Date(localTime).getMonth();
  let year = new Date(localTime).getFullYear();
  let setDay = new Date(localTime).setUTCDate(day);
  let setMonth = new Date(setDay).setUTCMonth(month);
  let setYear = new Date(setMonth).setUTCFullYear(year);
  return new Date(
    new Date(setYear).setUTCHours(hours, minuts, seconds, 0)
  ).toISOString();
};

// This function is used to convert the date to ISO format
export const convertDateToISO = () => {
  return new Date().toISOString();
};

// Function to format the date string for warranty display
export const formatDate = (inputDateString) => {
  const date = new Date(inputDateString);
  return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()} ${
    date.getHours() % 12 || 12
  }:${date.getMinutes()}:${date.getSeconds()} ${
    date.getHours() >= 12 ? 'PM' : 'AM'
  }`;
};

//function to covert date for warranty detail page
export const formatDateToShort = (inputDateString) => {
  const date = new Date(inputDateString);

  const options = { month: '2-digit', day: '2-digit', year: 'numeric' };
  return date.toLocaleString('en-US', options);
};

//function to covert date for warranty detail page
export const formatDateToLong = (inputDateString) => {
  const date = new Date(inputDateString);

  const options = {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  };
  return date.toLocaleString('en-US', options);
};

//Global date format mm/dd/yyyy
export const globalDateFormat = (currentDate) => {
  const dateString = currentDate;
  const dateObject = new Date(dateString);
  const formattedDate = dateObject.toLocaleDateString(
    DISPLAY_DATE_FORMAT.en_usFormat,
    {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }
  );
  return formattedDate;
};

//Global Time format 12.00 AM/PM
export const globalTimeFormat = (currentDate) => {
  const dateString = currentDate;
  const dateObject = new Date(dateString);
  const formattedTime = dateObject.toLocaleTimeString(
    DISPLAY_DATE_FORMAT.en_usFormat,
    {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    }
  );
  return formattedTime;
};

// function to convert date for bill class DATA Formate :
//Output: 09/19/2022 09:50:00 AM
export const convertedDate = (inputDateString) => {
  const date = new Date(inputDateString);

  const addLeadingZero = (value) => (value < 10 ? `0${value}` : value);

  const month = addLeadingZero(date.getMonth() + 1);
  const day = addLeadingZero(date.getDate());
  const year = date.getFullYear();
  const hours = addLeadingZero(date.getHours() % 12 || 12);
  const minutes = addLeadingZero(date.getMinutes());
  const seconds = addLeadingZero(date.getSeconds());
  const period = date.getHours() >= 12 ? 'PM' : 'AM';

  return `${month}/${day}/${year} ${hours}:${minutes}:${seconds} ${period}`;
};

// Find object by key
export const findObjectByKey = (arr, key, value) => {
  return arr.find((obj) => obj[key] === value);
};

// Function to format the date into 'Sept 12,2022 | 1:18:18 PM' format
export const formatDateIntoEnUS = (newDate) => {
  let date = new Date();
  if (newDate) {
    date = new Date(newDate);
  }
  const formattedDate = `${date.toLocaleString('en-US', {
    month: 'short',
  })} ${date.getDate()}, ${date.getFullYear()}  ${date.toLocaleTimeString(
    'en-US'
  )}`;
  return formattedDate;
};

// Function to replace object in array if that object exists else push the object
export const replaceObjectInArrayIfExist = (arr, key, value, newObject) => {
  const indexToUpdate = arr.findIndex((obj) => obj[key] === value);
  if (indexToUpdate !== -1) {
    return [
      ...arr.slice(0, indexToUpdate),
      newObject,
      ...arr.slice(indexToUpdate + 1),
    ];
  }
  return [...arr, newObject];
};

// Function to replace object in array
export const replaceObjectInArray = (arr, key, value, newObject) => {
  const indexToUpdate = arr.findIndex((obj) => obj[key] === value);
  if (indexToUpdate !== -1) {
    return [
      ...arr.slice(0, indexToUpdate),
      newObject,
      ...arr.slice(indexToUpdate + 1),
    ];
  }
  return arr;
};

// Function to convert 17:00 into 5:00 PM
// this is very specific to servic level Page
export const convertTimeTo12HourFormat = (value) => {
  const [hours, minutes] = value.split(':');
  const time = `${hours % 12 || 12}:${minutes} ${hours >= 12 ? 'PM' : 'AM'}`;
  return convertToISODate(time);
};

export function convertToISODate(timeString) {
  // Create a new Date object with today's date
  const today = new Date();
  // Extract hours and minutes from the time string
  const [hours] = timeString.split(':')?.map(Number);
  // Determine whether it's AM or PM
  const isPM = timeString.includes('PM');
  // Adjust hours for PM if needed
  const adjustedHours = isPM && hours !== 12 ? hours + 12 : hours;
  // Set the hours and minutes in the Date object
  today.setHours(adjustedHours, 0, 0); // Get the ISO string
  // Get the ISO string
  const isoDate = today.toISOString();
  return dayjs(isoDate);
}

// Function to remove duplicates from array based on key
export const removeDuplicates = (arr, key) => {
  return [...new Map(arr?.map((item) => [item[key], item])).values()];
};

//Convert Date for PriceSheet Effective Date OUTPUT: 2023-12-20
export const formatEffectiveDateTime = (date) => {
  const dateObject = new Date(date);
  const formattedDate = dayjs(dateObject).format('YYYY-MM-DD');

  return formattedDate;
};

//Calculate Calculation Fees based on Allocation Fees in Logistics Price Sheet
export const evalcalculatedFees = (allocationFees, percentMargin) => {
  // Ensure percentMargin is not equal to 1 to prevent division by zero
  if (percentMargin === 1) {
    return Infinity; // Returning Infinity to signify an error condition (division by zero)
  }

  let marginPercent = percentMargin > 0 ? percentMargin / 100 : 0;
  let calculatedFees = allocationFees / (1 - marginPercent);

  return calculatedFees;
};

// Scroll to top of the page
export const scrollToTop = () => {
  window.scrollTo(0, 0);
};

// convert any date into UTC format
export const convertToUTC = (date) => {
  const dateObject = new Date(date);
  const utcDate = dateObject.toLocaleString('en-US', { timeZone: 'UTC' });
  return utcDate;
};

// create function to genrate unique id in number
export const generateNumaricUniqueId = () => {
  const crypto = window.crypto || window.msCrypto;
  let randomArray = new Uint32Array(1);
  crypto.getRandomValues(randomArray); // Compliant for security-sensitive use cases
  const firstItem = randomArray[0];
  const trimmed = (+firstItem)?.toString();
  const randomValue = trimmed?.slice(0, 6);
  return Number(randomValue);
};

//Convert Date for PriceSheet Effective Date
export const datetoGlobalDateFormat = (date) => {
  const dateObject = new Date(date);
  const formattedDate = dayjs(dateObject).format('MM/DD/YYYY');

  return formattedDate;
};

export const validateDates = (fromDate, toDate) => {
  // Check if both from and to dates are selected
  if (fromDate && toDate) {
    const fromDateObj = dayjs(fromDate);
    const toDateObj = dayjs(toDate);

    // Compare the dates
    if (toDateObj.isBefore(fromDateObj)) {
      // Handle validation error (e.g., show an error message)
      // Msg: To date cannot be before From date
      return ENTITLEMENT_DATA.todateErrorMsg;
      // You can also prevent further action or display an error message here
    } else {
      // Dates are valid, proceed with further actions or processing
      // Msg: Dates are valid
      return 'valid';
    }
  } else {
    // If both dates are not selected yet, you might want to handle it accordingly
    // Msg: Please select both From and To dates
    // You can display a message to prompt users to select both dates
  }
};

//Convert Date for Search options Date as 2023-01-15
export const formatEntitlementsSearchDate = (date) => {
  const dateObject = new Date(date);
  const formattedDate = dayjs(dateObject).format('YYYY-MM-DD');

  return formattedDate;
};

export const formatEosDate = (date) => {
  if (!date || isNaN(new Date(date).getTime())) {
    return ''; // or any default value
  }

  const dateObject = new Date(date);
  const formattedDate = dayjs(dateObject).format('MMM D, YYYY');

  return formattedDate;
};

export const isObjectsEqual = (obj1, obj2) => {
  // Check if both arguments are exactly the same object or both are null/undefined
  if (obj1 === obj2) {
    return true;
  }

  // Check if only one is null/undefined
  if ((obj1 == null) !== (obj2 == null)) {
    return false;
  }

  // Check if both arguments are objects (including arrays, functions, etc.)
  if (typeof obj1 !== 'object' || typeof obj2 !== 'object') {
    return false;
  }

  // Get keys of both objects
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  // Check if number of properties is different
  if (keys1.length !== keys2.length) {
    return false;
  }

  // Compare each property
  for (const key of keys1) {
    // If obj2 doesn't have a property obj1 has
    if (!obj2.hasOwnProperty(key)) {
      return false;
    }

    const val1 = obj1[key];
    const val2 = obj2[key];

    // Handling strings: trim if both are strings
    const bothAreStrings = typeof val1 === 'string' && typeof val2 === 'string';
    if (bothAreStrings) {
      if (val1.trim() !== val2.trim()) {
        return false;
      }
    }
    // Handling objects (including arrays and nested objects)
    else if (typeof val1 === 'object' && typeof val2 === 'object') {
      if (!isObjectsEqual(val1, val2)) {
        return false;
      }
    }
    // Direct comparison for other types
    else if (val1 !== val2) {
      return false;
    }
  }

  return true;
};

export const getFormatedDate = (inputDateString, type = true) => {
  const inputDate = new Date(inputDateString);
  const year = inputDate.getFullYear();
  const month = String(inputDate.getMonth() + 1).padStart(2, '0');
  const day = String(inputDate.getDate()).padStart(2, '0');
  const hours = String(inputDate.getHours()).padStart(2, '0');
  const minutes = String(inputDate.getMinutes()).padStart(2, '0');
  const seconds = String(inputDate.getSeconds()).padStart(2, '0');
  let outputDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  if (type) return outputDateString;
  else return `${year}-${month}-${day}`;
};

// Function to format date and time
export const formatDateTime = (dateTime) => {
  if (!dateTime) {
    return { date: null, time: null };
  }
  const dateObj = new Date(dateTime);
  const date = dateObj.toISOString().split('T')[0];
  const time = dateObj.toISOString().split('T')[1].slice(0, -1);
  return { date, time };
};

//Converting date to DB date format i.e. from 02/11/2023 to 2023-11-02T19:18:37.109Z
export const convertDatetoDBDateFormat = (date) => {
  const dayjs = require('dayjs');
  const utc = require('dayjs/plugin/utc');
  if (utc) {
    dayjs.extend(utc);

    if (date) {
      let inputDate = date.toString();
      let formattedDate = dayjs(inputDate, 'mm/dd/yyyy').utc().format();
      return formattedDate;
    }
  }
};

export const dateChangeForPayload = (data) => {
  const date = new Date(data);
  // Extract the year, month, and day from the date object
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // getUTCMonth() returns month from 0-11
  const day = date.getDate();

  // Format the date string in 'YYYY-MM-DD' format and append 'T00:00:00' to set time to 00:00:00
  const formattedDate = `${year}-${month.toString().padStart(2, '0')}-${day
    .toString()
    .padStart(2, '0')}T00:00:00Z`;

  return formattedDate; // This will log dates like '2023-05-23T00:00:00'
};

//To check if date is valid date (time not considered)
export const isValidDate = (dateString) => {
  if (dateString === null || dateString === undefined || dateString === '')
    return false;

  const date = new Date(dateString);

  return dayjs(date?.toString()).isValid();
};

//Convert Date as 02/22/2024
export const formatGlobalDate = (date) => {
  if (date === null || date === undefined || date === '') return false;

  const dateObject = new Date(date);
  const formattedDate = dayjs(dateObject).format('MM/DD/YYYY');

  return formattedDate;
};

//Filterable Date Format MM/DD/YYYY, 00:00:00 AM
export const fiterableDateFormat = (date) => {
  if (date === null || date === undefined || date === '') return false;

  const dateObject = new Date(date);
  const extractTime = dayjs(dateObject).format('MM/DD/YYYY, hh:mm:ss A');

  return extractTime;
};

//format the date and time in MM/DD/YYYY hh:mm:ss A format 02/22/2024 12:00:00 AM
export const getDateTimeExtractFormat = (date) => {
  if (date === null || date === undefined || date === '') return false;

  const dateObject = new Date(date);
  const extractTime = dayjs(dateObject).format('MM/DD/YYYY hh:mm:ss A');

  return extractTime;
};

export const convertZoneToPriceClass = (zones) => {
  let tabName;
  if (
    zones?.contractZoneId === 1 ||
    zones?.contractZoneId === 2 ||
    zones?.contractZoneId === 3
  ) {
    tabName =
      CONTRACTS_DATA.extendedWarrentity.priceOptionTabName +
      zones?.contractZoneId;
  }
  if (
    zones?.contractZoneId ===
      CONTRACTS_DATA.extendedWarrentity.seasonalZoneId ||
    zones?.contractZoneId === CONTRACTS_DATA.extendedWarrentity.rentalZoneId ||
    zones?.contractZoneId === CONTRACTS_DATA.extendedWarrentity.deferralZoneId
  ) {
    tabName = zones.contractZoneName;
  }
  if (
    zones?.contractZoneId > 6 &&
    zones?.contractZoneId <= CONTRACTS_DATA.extendedWarrentity.maxZoneId
  ) {
    tabName =
      CONTRACTS_DATA.extendedWarrentity.priceOptionTabName +
      (zones?.contractZoneId - 3);
  }
  zones.contractZoneNameDisplay = tabName;
  return zones;
};

export const calculatedFeeCalculation = (annualFee, cpiValues) => {
  let calculatedFee = 0;
  annualFee = Number(annualFee);
  let cpiPercentage = Number(cpiValues?.cpiPercentage) || 0;
  calculatedFee = (annualFee * cpiPercentage) / 100 + annualFee;
  return calculatedFee || calculatedFee === 0 ? calculatedFee.toFixed(2) : '';
};

export const calculatedFeeCalculation_onFactor = (annualFee, factor) => {
  let calculatedFee = 0;
  annualFee = Number(annualFee);
  let factorNumber = Number(factor) || 1;
  calculatedFee = annualFee * factorNumber;
  return calculatedFee || calculatedFee === 0 ? calculatedFee.toFixed(2) : '';
};

export const convertToMidnight = (inputDate) => {
  const output =
    new Date(inputDate).toISOString().split('T')[0] + 'T00:00:00.000Z';
  return output;
};

export const resetCpiDateType = (input) => {
  const convertedDate = input.toISOString().split('T')[0] + '  00:00:00.000';
  return convertedDate;
};

// orderable object comparison
export const isEqual = (obj1, obj2) => {
  const obj1Keys = Object.keys(obj1);
  const obj2Keys = Object.keys(obj2);

  if (obj1Keys.length !== obj2Keys.length) return false;

  for (let key of obj1Keys) {
    if (obj1[key] !== obj2[key]) return false;
  }

  return true;
};

export const isMatch = (data1, data2) => {
  if (data1.length !== data2.length) return false;

  for (let obj1 of data1) {
    const match = data2.find((obj2) => isEqual(obj1, obj2));
    if (!match) return false;
  }

  return true;
};

export const compareAndSetDataEdited = (data1, data2) => {
  // Extract IDs from fetchOrderableCompareResult for comparison
  const fetchOrderableIds = data2.map((item) => item.id);

  // Check for extra objects in grandparentGridData with isDeleted: true
  const extraDeletedObjects = data1.filter((item) => {
    return !fetchOrderableIds.includes(item.id) && item.isDeleted === true;
  });
  // If there are extra objects that are deleted, set isDataEdited('')
  if (extraDeletedObjects.length > 0) {
    return true;
  } else {
    return false;
  }
};

export const arraysEqual = (arr1, arr2) => {
  if (arr1.length !== arr2.length) return false;

  for (let i = 0; i < arr1.length; i++) {
    if (!objectsEqual(arr1[i], arr2[i])) {
      return false;
    }
  }

  return true;
};

export const objectsEqual = (obj1, obj2) => {
  const keys1 = Object.keys(obj1).filter((key) => key !== 'id');
  const keys2 = Object.keys(obj2).filter((key) => key !== 'id');
  if (keys1.length !== keys2.length) return false;
  for (let key of keys1) {
    if (obj1[key] !== obj2[key]) {
      return false;
    }
  }
  return true;
};

export const PCSelectionTab_PCOptionsTab_SaveData = (
  data,
  selectedOpDefServiceOffering,
  loggedInUser
) => {
  let dataToSave = data
    .filter((item) => item?.isChanged)
    .map((item) => {
      item.contractId = item?.contractPriceClass?.contract_Id;
      item.priceClassId = item?.contractPriceClass?.price_Class_Id;
      item.lastModifiedUserId = loggedInUser;
      item.prepaymentDurationMonths =
        item?.contractPriceClass?.prepayment_Duration_Months;
      item.prepaymentFlag = item?.contractPriceClass?.prepayment_Flag;
      item.autoRenewFlag = item?.contractPriceClass?.auto_Renew_Flag;
      item.extendedServicesDurationMonths =
        item?.contractPriceClass?.extended_Services_Duration_Months;
      item.effectiveDate = item?.contractPriceClass?.effective_Date_To_Save
        ? item?.contractPriceClass?.effective_Date_To_Save
        : item?.contractPriceClass?.effective_Date;
      item.deferralServiceOfferingId =
        item?.contractPriceClass?.deferral_Service_Offering_Id !==
        COMMON_MESSAGE.noneWithBracket
          ? item?.contractPriceClass?.deferral_Service_Offering_Id
          : null;
      if (
        item.contractPriceClass?.deferral_Service_Offering_Id !==
        item.contractPriceClass?.old_deferral_Service_Offering_Id
      ) {
        item.newDeferralServiceOfferingName =
          selectedOpDefServiceOffering?.find(
            (newItem) =>
              newItem?.serviceOfferingId ===
              item?.contractPriceClass?.deferral_Service_Offering_Id
          )?.serviceOfferingName || '';
        item.deferralServiceOfferingName =
          selectedOpDefServiceOffering?.find(
            (newItem) =>
              newItem?.serviceOfferingId ===
              item?.contractPriceClass?.old_deferral_Service_Offering_Id
          )?.serviceOfferingName || '';
      }
      item.contractSelections =
        item?.priceClassSelectionTab
          .filter((item) => item?.isChanged)
          .map((pcSelection) => {
            pcSelection.contractZoneName = pcSelection?.contractZoneNameDisplay;
            delete pcSelection['services'];
            delete pcSelection['old_selectedServiceOfferingId'];
            delete pcSelection['old_serviceOfferingName'];
            delete pcSelection['isChanged'];
            delete pcSelection['selectedServiceOfferingIndex'];
            delete pcSelection['unId'];
            delete pcSelection['factor'];
            delete pcSelection['contractZoneNameDisplay'];
            delete pcSelection['priceClassId'];
            delete pcSelection['selectedServiceOfferingId'];
            delete pcSelection['PC_Index'];
            delete pcSelection['factor'];
            return pcSelection;
          }) || [];
      delete item['contractPriceClass'];
      delete item['factor'];
      delete item['prepayment_Duration_Months'];
      delete item['extended_Services_Duration_Months'];
      delete item['isChanged'];
      delete item['selectedPC'];
      delete item['priceClassSelectionTab'];
      return item;
    });
  return dataToSave;
};

//format the date and time in MM/DD/YYYY hh:mm:ss A format 02/22/2024 12:00:00 AM in UTC format
export const dateTimeUTCFormat = (date) => {
  if (date) {
    let formattedDate = new Date(date);
    const newDateUTC = datetoGlobalDateFormat(formattedDate.toISOString());

    return `${newDateUTC}`;
  }
};

export const convertedDateForContractOverride = (inputDateString) => {
  if (
    inputDateString === null ||
    inputDateString === undefined ||
    inputDateString === ''
  ) {
    return null;
  }
  const date = new Date(inputDateString);

  const addLeadingZero = (value) => (value < 10 ? `0${value}` : value);

  const month = addLeadingZero(date.getMonth() + 1);
  const day = addLeadingZero(date.getDate());
  const year = date.getFullYear();
  const hours = addLeadingZero(date.getHours() % 12 || 12);
  const minutes = addLeadingZero(date.getMinutes());
  const seconds = addLeadingZero(date.getSeconds());
  const period = date.getHours() >= 12 ? 'PM' : 'AM';

  return `${month}/${day}/${year} ${hours}:${minutes}:${seconds} ${period}`;
};

// extract date from eosDate payload remove time for minus 1 date issue
export const extractDate = (date) => {
  if (date) {
    let formattedDate = new Date(date);
    const year = formattedDate.getFullYear();
    const month = (formattedDate.getMonth() + 1).toString().padStart(2, '0');

    const day = formattedDate.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  } else {
    return '';
  }
};

export const changeESTDateFormat = (date, format) => {
  if (date) {
    let newDate = new Date(date);
    if(format === 'EST') {
      format = 'MM/DD/YYYY';
    }

    if(format === 'ESTDASH') {
      format = 'YYYY-MM-DD';
    }
    
    let formattedDate = dayjs(newDate).format(format); 
    
    if(format?.indexOf('EST') > - 1) { 
    formattedDate = formattedDate + 'T00:00:00Z';
    }
    
    return formattedDate;
  }
};

export const changeDateFormat = (date) => {
  if (date) {
    let newDate = new Date(date);
    newDate =
      newDate.getMonth() +
      1 +
      '/' +
      newDate.getDate() +
      '/' +
      newDate.getFullYear();

    let formattedDate = newDate;
    return formattedDate;
  }
};
